import RegularButton from "components/CustomButtons/Button";
import React, { memo, useMemo } from "react";
import { Box, Divider, Grid } from "@mui/material";
import { blue } from "@mui/material/colors";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { FolderZip } from "@mui/icons-material";
import { validateObject } from "helpers/validateObject";
import { GridGN4Invoice } from "./GridGN4Invoice";
import { CreLicenseRow } from "./CreLicenseRow";
import { useFormGlobalInvoice } from "./useFormGlobalInvoice";
import { ConfirmBreakdownModal } from "./ConfirmBreakdownModal";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  position: "relative",
};

export const FormGlobalInvoice = memo(() => {
  const {
    loading,
    sales,
    billsGn4,
    billsNoGn4,
    pendingToBill,
    manualNoGn4,
    toggleManualNoGn4,
    handleNoGn4Field,
    totalToBill,
    pendingByCreLicense,
    originalPayments,
    globalInvoice,
    station,
    isInvoiceValid,
    expandedLicense,
    toggleLicense,
    invoiceIds,
    handleDownloadZip,
    isDownload,
    selectedPayments,
    onTogglePayment,
    openBreakdown,
    setOpenBreakdown,
    handleSubmitBreakdown,
    getBreakdownModalData,
  } = useFormGlobalInvoice();

  const showTimbrarButton =
    station !== null &&
    pendingByCreLicense.length > 0 &&
    validateObject(globalInvoice) &&
    isInvoiceValid;

  const breakdownModalData = useMemo(
    () => (openBreakdown ? getBreakdownModalData() : []),
    [openBreakdown, getBreakdownModalData],
  );

  return (
    <>
      {loading ? (
        <Box style={{ height: 80 }}>
          <LoadingComponent />
        </Box>
      ) : (
        <form style={{ width: "100%", padding: 4 }}>
          <Grid container spacing={1}>
            <GridGN4Invoice title="Venta GN4 (reporte del dia)" data={sales} />

            {pendingByCreLicense.map((license) => (
              <CreLicenseRow
                key={license.creLicense}
                license={license}
                expanded={expandedLicense === license.creLicense}
                onToggle={toggleLicense(license.creLicense)}
                selectedPayments={selectedPayments}
                onTogglePayment={onTogglePayment}
                originalPayments={originalPayments}
              />
            ))}

            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
            </Grid>

            <GridGN4Invoice
              title="Total Acumulado a Facturar"
              data={totalToBill}
              accent
            />
            <GridGN4Invoice title="Facturación GN4" data={billsGn4} accent />
            <GridGN4Invoice
              title="Facturación No GN4"
              hint="Informativo: no afecta el timbrado"
              data={billsNoGn4}
              accent
              manual={manualNoGn4}
              onToggleManual={toggleManualNoGn4}
              onChangeAmount={handleNoGn4Field("total")}
              onChangeQuantity={handleNoGn4Field("quantity")}
            />
            <GridGN4Invoice
              title="Facturación Pendiente"
              data={pendingToBill}
              accent
            />

            <Grid item xs={12}>
              <Grid
                container
                spacing={1}
                style={{ ...style, justifyContent: "center", marginTop: 16 }}
              >
                <Grid
                  item
                  xs={12}
                  sm={5}
                  style={{ ...style, justifyContent: "center" }}
                >
                  {showTimbrarButton && (
                    <RegularButton
                      variant="contained"
                      color="facebook"
                      style={{
                        backgroundColor: blue[900],
                        width: "28%",
                        color: "white",
                      }}
                      onClick={setOpenBreakdown}
                    >
                      Timbrar
                    </RegularButton>
                  )}
                  {invoiceIds.length > 0 && (
                    <RegularButton
                      round
                      justIcon
                      style={{ margin: 4 }}
                      color="success"
                      onClick={handleDownloadZip}
                      tooltip="Descargar ZIP"
                      disabled={isDownload}
                    >
                      <FolderZip style={{ color: "white" }} />
                    </RegularButton>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}

      <ConfirmBreakdownModal
        open={openBreakdown}
        onClose={setOpenBreakdown}
        onSubmit={handleSubmitBreakdown}
        isLoading={loading}
        selectedData={breakdownModalData}
      />
    </>
  );
});
